var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V6C7 6.55228 7.44772 7 8 7C8.55229 7 9 6.55228 9 6V1ZM4.9989 4.86666C5.47754 4.59113 5.64219 3.97975 5.36666 3.5011C5.09113 3.02246 4.47975 2.85781 4.0011 3.13334C1.61296 4.50808 0 7.08185 0 10.034C0 14.4381 3.58632 18 8 18C12.4137 18 16 14.4381 16 10.034C16 7.08185 14.387 4.50808 11.9989 3.13334C11.5203 2.85781 10.9089 3.02246 10.6333 3.5011C10.3578 3.97975 10.5225 4.59113 11.0011 4.86666C12.7976 5.90081 14 7.82945 14 10.034C14 13.3244 11.3183 16 8 16C4.68169 16 2 13.3244 2 10.034C2 7.82945 3.20243 5.90081 4.9989 4.86666Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.9451dd1615a10d2e4b4f2eea450fc32b.svg";
export { ForwardRef as ReactComponent };